<template>
  <b-form>
    <!-- DATOS DE OCUPACIÓN -->
    <b-row class="mt-2">
      <!-- DEPENDENCIA -->
      <b-col
        v-if="isObject(dependencia) && !isEmptyObject(dependencia)"
        md="6"
      >
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="dependencia"
            rules="required"
          >
            <b-form-input
              v-model="dependencia.nombre"
              disabled
              :state="errors.length > 0 ? false:null"
              placeholder="Dependencia"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- ENTIDAD FEDERATIVA -->
      <b-col
        v-if="isObject(entidadFederativa) && !isEmptyObject(entidadFederativa)"
        md="6"
      >
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="entidad federativa"
            rules="required"
          >
            <b-form-input
              v-model="entidadFederativa.nombre"
              disabled
              :state="errors.length > 0 ? false:null"
              placeholder="Entidad Federativa"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <p>Por favor <strong>seleccione su área de adscripción y/o puesto</strong>, sólo en caso de no encontrar los deseados en los catálogos correspondientes, presione el botón <strong>"No encuentro mi área de adscripción, quiero escribir uno nuevo"</strong> o <strong>"No encuentro mi puesto, quiero escribir uno nuevo"</strong>, para realizar la captura de manera manual.</p>
          </div>
        </b-alert>
      </b-col>

      <!-- DEPARTAMENTO -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="área de adscripción"
            rules="required"
          >
            <v-select
              v-if="!writeDepartamento.show"
              v-model="ocupacion.departamento"
              :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
              :options="departamentos"
              placeholder="Seleccione su área de adscripción"
              label="nombre"
              :clearable="false"
              filterable
            >
              <template #no-options>
                Sin resultados
              </template>
            </v-select>
            <b-form-input
              v-else
              v-model="ocupacion.dptoAlterno"
              :state="errors.length > 0 ? false:null"
              placeholder="Ingrese área de adscripción"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Botón para cambiar select por input para escribir nuevo -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="mb-1"
          block
          size="sm"
          :variant="writeDepartamento.hover ? 'primary' : 'secondary'"
          @click="changeInputDpto()"
          @mouseover="writeDepartamento.hover = true"
          @mouseleave="writeDepartamento.hover = false"
        >
          <feather-icon
            :icon="writeDepartamento.show ? 'MousePointerIcon' : 'Edit3Icon'"
            class="mr-50"
          />
          <span class="align-middle">
            {{ writeDepartamento.show ? 'Volver al selector de áreas de adscripción' : 'No encuentro mi área de adscripción, quiero escribir una nueva' }}
          </span>
        </b-button>
      </b-col>
      <!-- PUESTO / CARGO -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="puesto"
            rules="required"
          >
            <v-select
              v-if="!writePuesto.show"
              v-model="ocupacion.puesto"
              :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
              :options="puestos"
              placeholder="Seleccione su puesto/cargo"
              label="nombre"
              :clearable="false"
              filterable
            >
              <template #no-options>
                Sin resultados
              </template>
            </v-select>
            <b-form-input
              v-else
              v-model="ocupacion.puestoalterno"
              :state="errors.length > 0 ? false:null"
              placeholder="Ingrese puesto/cargo"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Botón para cambiar select por input para escribir nuevo -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="mb-1"
          block
          size="sm"
          :variant="writePuesto.hover ? 'primary' : 'secondary'"
          @click="changeInputPuesto()"
          @mouseover="writePuesto.hover = true"
          @mouseleave="writePuesto.hover = false"
        >
          <feather-icon
            :icon="writePuesto.show ? 'MousePointerIcon' : 'Edit3Icon'"
            class="mr-50"
          />
          <span class="align-middle">
            {{ writePuesto.show ? 'Volver al selector de puestos' : 'No encuentro mi puesto, quiero escribir uno nuevo' }}
          </span>
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { isEmptyObject, isObject } from '@core/utils/utils'
import {
  confirmed,
  email,
  password,
  required,
} from '@validations'
import {
  BAlert,
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
    BButton,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    dependencia_cargada: {
      type: Object,
      required: true,
      default: () => {},
    },
    // eslint-disable-next-line vue/prop-name-casing
    entidad_fed: {
      type: Object,
      required: true,
      default: () => {},
    },
    departamentos: {
      type: Array,
      required: true,
      default: () => [],
    },
    puestos: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      dependencia: {},
      ocupacion: {
        puestoalterno: null,
        dptoAlterno: null,
      },
      entidadFederativa: {},
      selectedContry: 'select_value',
      selectedLanguage: 'nothing_selected',
      writePuesto: {
        show: false,
        hover: false,
      },
      writeDepartamento: {
        show: false,
        hover: false,
      },
      // VALIDATIONS
      required,
      password,
      email,
      confirmed,
      isObject,
      isEmptyObject,
    }
  },
  watch: {
    dependencia_cargada(value) {
      this.dependencia = value
    },
    entidad_fed(value) {
      this.entidadFederativa = value
    },
  },
  methods: {
    changeInputPuesto() {
      if (!this.writePuesto.show) this.ocupacion.puesto = { id: 2, nombre: 'Desconocido' }
      else this.ocupacion.puestoalterno = null
      this.writePuesto.show = !this.writePuesto.show
    },
    changeInputDpto() {
      if (!this.writeDepartamento.show) this.ocupacion.departamento = { id: 27, nombre: 'Desconocido' }
      else this.ocupacion.dptoAlterno = null
      this.writeDepartamento.show = !this.writeDepartamento.show
    },
  },
}
</script>
